import { useEffect, useState } from "react";

import CrudModal from "components/crud/CrudModal";
import CrudInput from "components/crud/CrudInput";
import CrudSelect from "components/crud/CrudSelect";

import {
    createSampleReturn,
} from "services/api/sampleTrackingApi";

import {
    showSuccess,
    showError,
} from "utils/toast";


export default function ReturnModal({
    open,
    onClose,
    reload,
    item,
}) {

    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        form,
        setForm,
    ] = useState({

        returnDate: "",
        quantity: 1,
        condition: "good",
        remarks: "",

    });


    useEffect(
        () => {

            if (!open) {
                return;
            }


            setForm({

                returnDate:
                    new Date()
                        .toISOString()
                        .substring(
                            0,
                            10
                        ),

                quantity: 1,

                condition:
                    "good",

                remarks:
                    "",

            });

        },
        [
            open,
        ]
    );


    const handleChange =
        (e) => {

            const {
                name,
                value,
            } = e.target;


            setForm(
                (prev) => ({
                    ...prev,
                    [name]:
                        value,
                })
            );

        };


    const remaining =
        Number(
            item?.summary?.remainingQuantity ||
            0
        );


    const handleSubmit =
        async (e) => {

            e.preventDefault();


            if (
                Number(
                    form.quantity
                ) < 1
            ) {

                showError(
                    "Quantity must be at least 1."
                );

                return;
            }


            if (
                Number(
                    form.quantity
                ) > remaining
            ) {

                showError(
                    `Only ${remaining} sample(s) are available.`
                );

                return;
            }


            try {

                setLoading(
                    true
                );


                await createSampleReturn(
                    item.id,
                    {
                        returnDate:
                            form.returnDate,

                        quantity:
                            Number(
                                form.quantity
                            ),

                        condition:
                            form.condition,

                        remarks:
                            form.remarks ||
                            undefined,
                    }
                );


                showSuccess(
                    "Sample return recorded successfully."
                );


                await reload();

                onClose();

            } catch (
                error
            ) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to record sample return."
                );

            } finally {

                setLoading(
                    false
                );

            }

        };


    if (!open) {
        return null;
    }


    return (

        <CrudModal

            open={open}

            title="Record Sample Return"

            loading={loading}

            submitText="Record Return"

            onClose={onClose}

            onSubmit={handleSubmit}

            width="max-w-xl"
        >

            <div
                className="
                    mb-5
                    rounded-xl
                    bg-blue-50
                    p-4
                "
            >

                <div
                    className="
                        text-sm
                        text-gray-600
                    "
                >
                    Available for return
                </div>

                <div
                    className="
                        mt-1
                        text-2xl
                        font-bold
                        text-blue-700
                    "
                >
                    {remaining}
                </div>

            </div>


            <div
                className="
                    grid
                    grid-cols-1
                    gap-5
                    md:grid-cols-2
                "
            >

                <CrudInput
                    label="Return Date"
                    type="date"
                    name="returnDate"
                    value={
                        form.returnDate
                    }
                    onChange={
                        handleChange
                    }
                />


                <CrudInput
                    label="Quantity"
                    type="number"
                    min="1"
                    max={
                        remaining
                    }
                    name="quantity"
                    value={
                        form.quantity
                    }
                    onChange={
                        handleChange
                    }
                />

            </div>


            <div className="mt-5">

                <CrudSelect
                    label="Condition"
                    name="condition"
                    value={
                        form.condition
                    }
                    onChange={
                        handleChange
                    }
                    options={[

                        {
                            value: "good",
                            label: "Good",
                        },

                        {
                            value: "damaged",
                            label: "Damaged",
                        },

                        {
                            value: "lost",
                            label: "Lost",
                        },

                        {
                            value: "other",
                            label: "Other",
                        },

                    ]}
                />

            </div>


            <div className="mt-5">

                <CrudInput
                    label="Remarks"
                    name="remarks"
                    value={
                        form.remarks
                    }
                    onChange={
                        handleChange
                    }
                />

            </div>

        </CrudModal>
    );
}